import React from 'react';
import { useSelector } from 'react-redux';
import { epochToDateString } from '../../../../../helper';
import { getBtnColor, getBtnText, getUpdateStatus } from '../../../helper';
import { selectUser } from '../../../../../redux/reducers/userReducer';
import { useStoryPresence } from '../../../../../hooks/useStoryPresence';

import './StoryDetail.css';

type Props = {
  story: any;
  updateStoryStatusToServer: Function;
};

const StoryDetail: React.FC<Props> = ({ story, updateStoryStatusToServer }) => {
  const user = useSelector(selectUser);
  const presenceHolder = useStoryPresence(
    story?.id,
    user.data?.user.user_id,
    user.data?.user.name || '',
    'reviewing'
  );

  return (
    <div className='main-sroty-detail-admin'>
      {presenceHolder && (
        <div
          style={{
            background: '#FFF4E5',
            border: '1px solid #F0B429',
            borderRadius: 6,
            color: '#8A5A00',
            fontFamily: 'Nunito Sans',
            fontSize: 14,
            fontWeight: 600,
            padding: '8px 14px',
            marginBottom: 8,
          }}
        >
          ⚠️ {presenceHolder.name} is also in this story right now (
          {presenceHolder.activity}).
        </div>
      )}
      <div className='header-container'>
        <h6 style={{ color: 'grey' }}>{'Home > Stories'}</h6>
        <span>
          <button
            style={{
              padding: '8px 16px',
              color: getBtnColor(story.status),
              border: '1.5px solid',
              borderRadius: '20px',
            }}
            className='save-a-Briefing'
            onClick={() => {
              updateStoryStatusToServer(story, getUpdateStatus(story.status));
            }}
          >
            {getBtnText(story.status)}
          </button>
          <button
            style={{
              padding: '8px 16px',
              color: 'red',
              border: '1.5px solid',
              borderRadius: '20px',
              marginLeft: 10,
            }}
            className='save-a-Briefing'
            onClick={() => {
              updateStoryStatusToServer(story, 'rejected');
            }}
          >
            Reject
          </button>
        </span>
      </div>
      <div className='story-detail-container-admin'>
        <div className='story-main-content-admin'>
          <div>
            <div className='story-detail-heading-admin'>
              {story?.heading || ''}
            </div>
          </div>

          <div className='story-content-admin'>
            <div className='profile-admin'>
              <img
                className='profile-image-admin'
                src='/assets/profile.png'
                alt='Profile'
              />
              <div className='profile-details-admin'>
                <div className='profile-name-admin'>John Doe</div>
                <div className='story-detail-profile-time-admin'>
                  {epochToDateString(story.createdAt._seconds)} •
                  {story?.topic.map((topic) => topic + ' ')}
                </div>
              </div>
            </div>

            <hr className='divider-admin' />

            <div
              className='story-text-admin'
              dangerouslySetInnerHTML={{ __html: story?.content || '' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryDetail;
